import React, { useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import { getFooterButtonHiddenClass } from 'flow/utils/meeting-footer-utils';
import MeetingButton from 'flow/components/meeting/MeetingButton';
import MeetingDeviceSettingsDialog from './shared/MeetingDeviceSettingsDialog';

/**
 * Footer (start-side) button + popover for device settings. Hides once the
 * footer is too narrow to hold it; the more-menu takes over the entry then.
 */
const MeetingDeviceSettingsButton = () => {
    const { i18next } = useAppContext();
    const [displaySettings, setDisplaySettings] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);

    return (
        <div
            ref={anchorRef}
            className={twMerge(
                'flex items-center select-none',
                getFooterButtonHiddenClass(),
            )}
        >
            <MeetingButton
                iconType="general"
                active={displaySettings}
                subtleActive={true}
                callback={() => setDisplaySettings((isOpen) => !isOpen)}
                hoverText={i18next.t('settings')}
                circular={true}
            />
            {displaySettings && (
                <MeetingDeviceSettingsDialog
                    anchorEl={anchorRef.current}
                    placement="top-start"
                    onClose={() => setDisplaySettings(false)}
                />
            )}
        </div>
    );
};

export default MeetingDeviceSettingsButton;
